import { Mesh, SphereBufferGeometry, Object3D } from "three";
import { BufferGeometryUtil } from "../../utils/BufferGeometryUtil";
var Dumplings = /** @class */ (function () {
    function Dumplings(params, $paramObjArray) {
        this.mesh_child = new Mesh(Dumplings.geometry, [
            params.materials.getMaterialByName('Dumpling1'),
            params.materials.getMaterialByName('Dumpling2'),
            params.materials.getMaterialByName('Dumpling3')
        ]);
        this.mesh_child.position.set(0, 0, 0);
        this.mesh_child.scale.set(1, 1, 1);
        this.mesh_child.name = $paramObjArray[0].name + "_child";
        this.mesh = new Object3D();
        this.mesh.name = $paramObjArray[0].name;
        this.mesh.add(this.mesh_child);
    }
    Dumplings.init = function () {
        var sizes = [2, 3, 4];
        var geometry1 = new SphereBufferGeometry(sizes[0], 32, 32);
        var geometry2 = new SphereBufferGeometry(sizes[1], 32, 32);
        var geometry3 = new SphereBufferGeometry(sizes[2], 32, 32);
        // 玉の半径の20%だけめり込ませる
        var sinking = 0.2;
        geometry1.translate(0, sizes[0] + sizes[1] - sinking * sizes[1], 0);
        geometry3.translate(0, -(sizes[1] + sizes[2] - sinking * sizes[2]), 0);
        var geometries = [geometry1, geometry2, geometry3];
        // AO用にuv2をuvからコピーして追加
        geometries.forEach(function (geometry) {
            geometry.attributes.uv2 = geometry.attributes.uv;
        });
        // ジオメトリマージ
        this.geometry = BufferGeometryUtil.merge(geometries, {
            names: ['position', 'normal', 'uv', 'uv2'],
            itemSizes: [3, 3, 2, 2],
        }, [0, 1, 2]);
    };
    return Dumplings;
}());
export { Dumplings };
